import './App.css';
import LoaderShowcase from './Pages/LoaderShowcase';

function App() {
  return (
    <div className="App">
      <LoaderShowcase></LoaderShowcase>
    </div>
  );
}

export default App;
